import * as I from "immutable";
import Raven from "raven-js";
import React, {Component} from "react";
import PropTypes from "prop-types";

import {TIME_FORMAT} from "config/constants";
import {trackEvent} from "metrics";

import api from "v2/api";
import {getDestination} from "v2/api/Destinations";
import {Route} from "v2/api/Records";
import ModalForm from "v2/components/responsive/ModalForm";

export default class DeleteDestinationForm extends Component {
  static contextTypes = {
    location: PropTypes.object,
    onUpdateRouteData: PropTypes.func,
    params: PropTypes.shape({
      date: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      routeId: PropTypes.string.isRequired,
    }),
    routeData: PropTypes.instanceOf(Route),
    router: PropTypes.object,
  }
  static propTypes = {
    modal: PropTypes.bool,
    onCancel: PropTypes.func,
  }

  state = {
    submitted: false,
  }

  handleSubmit = (evt) => {
    evt.preventDefault();
    this.setState({
      submitted: true,
    });

    const {
      location: {query},
      onUpdateRouteData,
      params: {date, routeId, id},
      routeData,
      router,
    } = this.context;
    const {modal, onCancel} = this.props;

    const destination = getDestination(routeData, id);

    api()
      .delete(this.apiUrl, {
        validateStatus: (status) => status === 204,
      })
      .then(() => {
        onUpdateRouteData(null, () => {
          if (modal) {
            onCancel();
          }
          trackEvent("Delete Destination", ["Destination", "delete", id], {
            Date: date,
            ID: id,
            "Is Revisit?": destination.isRevisit,
            "Route ID": routeId,
            Type: destination.type,
          });
          router.push({
            pathname: `/${date}/${routeId}`,
            query,
          });
        });
      })
      .catch((err) => {
        if (err.response) {
          this.setState({
            errors: I.Map(err.response.data),
            submitted: false,
          });
        } else {
          Raven.captureException(err);
        }
      });
  }

  get apiUrl() {
    const {params: {id, routeId}} = this.context;
    return `/routes/${routeId}/destinations/${id}`;
  }

  renderContent() {
    const {params: {id}, routeData} = this.context;
    const destination = getDestination(routeData, id);
    if (!destination) {
      return null;
    }

    return [
      <p className="text-danger" key="danger">
        <strong>
          This operation cannot be undone.
        </strong>
      </p>,
      <p key="normal">
        Destination {destination.title} from
        {" "}{destination.estStartTime.format(TIME_FORMAT)} to
        {" "}{destination.estEndTime.format(TIME_FORMAT)} will be
        entirely removed from the route.
      </p>,
    ];
  }

  render() {
    const {submitted} = this.state;
    return (
      <ModalForm
        btnSubmitClassName="btn-danger"
        btnSubmitDisabled={submitted}
        btnSubmitLabel="Delete"
        modalTitle="Are You Sure?"
        onSubmit={this.handleSubmit}
        pageTitle="Delete Destination"
        {...this.props}>
        {this.renderContent()}
      </ModalForm>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/responsive/DeleteDestinationForm.js
 **/